import type { DownloadAreaState } from './types';

export const downloadAreaInitialState: DownloadAreaState = {
  data: {
    downloading: false,
    reportList: [],
  },
};
